// extracted by mini-css-extract-plugin
export default {"stripeRows":"stripeRows__MjuzyM"};